import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Tab, Button, Modal, Form, Spinner, Badge, Collapse } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import 'moment/locale/tr';
import '../styles/Home.css';
// Moment.js'i Türkiye saat dilimine ayarla
moment.locale('tr');

// E-mail etiketleri için bileşen
const EmailTag = ({ email, onRemove }) => {
  return (
    <Badge 
      bg="primary" 
      className="me-2 mb-2 p-2 d-inline-flex align-items-center"
      style={{ fontSize: '0.9rem' }}
    >
      {email}
      <span 
        className="ms-2" 
        style={{ cursor: 'pointer' }} 
        onClick={() => onRemove(email)}
      >
        &times;
      </span>
    </Badge>
  );
};

const ReminderList = ({ reminders, onEdit, onDelete }) => {
  const [openItems, setOpenItems] = useState({});
  const [sortField, setSortField] = useState('dateTime');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filterText, setFilterText] = useState('');
  const filterInputRef = useRef(null);

  useEffect(() => {
    filterInputRef.current?.focus();
  }, []);

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const formatDate = (date) => {
    return moment(date).format('DD.MM.YYYY - HH:mm');
  };
  
  const getRecurringText = (reminder) => {
    if (!reminder.isRecurring) return null;
    let typeText = '';
    switch (reminder.recurringType) {
      case 'minute': typeText = 'dakikada'; break;
      case 'hour': typeText = 'saatte'; break;
      case 'day': typeText = 'günde'; break;
      case 'month': typeText = 'ayda'; break;
      case 'year': typeText = 'yılda'; break;
      default: typeText = 'günde';
    }
    return `${reminder.recurringCount} ${typeText} bir tekrarlanıyor`;
  };

  // Filtreleme
  const filteredReminders = reminders.filter(reminder => {
    const search = filterText.toLowerCase();
    const title = reminder.title?.toLowerCase() || '';
    const user = (reminder.user?.fullName || `${reminder.user?.firstName || ''} ${reminder.user?.lastName || ''}`).toLowerCase();
    const date = formatDate(reminder.dateTime).toLowerCase();
    return (
      title.includes(search) ||
      user.includes(search) ||
      date.includes(search)
    );
  });

  // Sıralama fonksiyonu
  const sortedReminders = [...filteredReminders].sort((a, b) => {
    let aValue, bValue;
    if (sortField === 'title') {
      aValue = a.title?.toLowerCase() || '';
      bValue = b.title?.toLowerCase() || '';
    } else if (sortField === 'dateTime') {
      aValue = new Date(a.dateTime);
      bValue = new Date(b.dateTime);
    } else if (sortField === 'user') {
      aValue = (a.user?.fullName || `${a.user?.firstName || ''} ${a.user?.lastName || ''}`).toLowerCase();
      bValue = (b.user?.fullName || `${b.user?.firstName || ''} ${b.user?.lastName || ''}`).toLowerCase();
    }
    if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  // Sıralama başlığına tıklama
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection(field === 'dateTime' ? 'desc' : 'asc');
    }
  };

  // Sıralama okları
  const renderSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? <span> ▲</span> : <span> ▼</span>;
  };
  
  return (
    <>
      <div className="mb-2 d-flex justify-content-end">
        <input
          ref={filterInputRef}
          type="text"
          className="form-control"
          style={{ maxWidth: 300 }}
          placeholder="Filtrele: başlık, ekleyen, tarih..."
          value={filterText}
          onChange={e => setFilterText(e.target.value)}
        />
          </div>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col" style={{ width: '40px' }}></th>
              <th scope="col" style={{ cursor: 'pointer' }} onClick={() => handleSort('title')}>
                Başlık{renderSortIcon('title')}
              </th>
              <th scope="col" style={{ width: '100px' }}>Genel</th>
              <th scope="col" style={{ cursor: 'pointer' }} onClick={() => handleSort('dateTime')}>
                Hatırlatma Tarihi{renderSortIcon('dateTime')}
              </th>
              <th scope="col" style={{ width: '150px', cursor: 'pointer' }} onClick={() => handleSort('user')}>
                Ekleyen{renderSortIcon('user')}
              </th>
              <th scope="col" style={{ width: '200px' }}>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {sortedReminders.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center text-muted py-3">Filtreye uygun hatırlatma bulunamadı.</td>
              </tr>
            ) : (
              sortedReminders.map((reminder) => (
                <React.Fragment key={reminder._id}>
                  <tr 
                    className={`accordion-toggle ${!openItems[reminder._id] ? 'collapsed' : ''}`}
                    onClick={() => toggleItem(reminder._id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td className="expand-button"></td>
                    <td>{reminder.title}</td>
                    <td className="text-center">
                      {reminder.isPublic ? (
                        <Badge bg="danger">Evet</Badge>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>{formatDate(reminder.dateTime)}</td>
                    <td className="text-center">
                      {reminder.user && reminder.user.firstName && reminder.user.lastName
                        ? `${reminder.user.firstName} ${reminder.user.lastName}`
                        : '-'}
                    </td>
                    <td onClick={e => e.stopPropagation()}>
            <Button 
              variant="outline-primary" 
              size="sm" 
              className="me-2"
              onClick={() => onEdit(reminder)}
            >
              Düzenle
            </Button>
            <Button 
              variant="outline-danger" 
              size="sm"
              onClick={() => onDelete(reminder)}
            >
              Sil
            </Button>
                    </td>
                  </tr>
                  <tr className="hide-table-padding">
                    <td colSpan="6" className="p-0">
                      <Collapse in={openItems[reminder._id]}>
                        <div>
                          <div className="p-3">
                            {reminder.description && (
                              <div className="row mb-2">
                                <div className="col-2 fw-bold">Açıklama:</div>
                                <div className="col">{reminder.description}</div>
        </div>
        )}
        {reminder.isRecurring && (
                              <div className="row mb-2">
                                <div className="col-2 fw-bold">Tekrar:</div>
                                <div className="col">
                                  <Badge bg="info">{getRecurringText(reminder)}</Badge>
                                </div>
          </div>
        )}
        {reminder.additionalEmails && reminder.additionalEmails.length > 0 && (
                              <div className="row mb-2">
                                <div className="col-2 fw-bold">Diğer Alıcılar:</div>
                                <div className="col">
                                  {reminder.additionalEmails.map((email, i) => (
                                    <Badge key={i} bg="secondary" className="me-1">{email}</Badge>
              ))}
            </div>
          </div>
        )}
                            <div className="row">
                              <div className="col text-muted text-end">
                                <small>Eklenme: {moment(reminder.createdAt).format('DD.MM.YYYY - HH:mm')}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Collapse>
                    </td>
                  </tr>
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
        </div>
    </>
  );
};

const Home = () => {
  const { user } = useAuth();
  const [activeReminders, setActiveReminders] = useState([]);
  const [inactiveReminders, setInactiveReminders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentReminder, setCurrentReminder] = useState(null);
  const [usedEmails, setUsedEmails] = useState([]);
  const [emailInput, setEmailInput] = useState('');
  
  // Form state
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [dateTime, setDateTime] = useState('');
  const [additionalEmails, setAdditionalEmails] = useState([]);
  const [isRecurring, setIsRecurring] = useState(false);
  const [recurringCount, setRecurringCount] = useState(1);
  const [recurringType, setRecurringType] = useState('day');
  const [isPublic, setIsPublic] = useState(false);
  
  // Hatırlatmaları getir
  const fetchReminders = async () => {
    try {
      setLoading(true);
      
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      
      // Aktif hatırlatmaları getir
      const activeRes = await axios.get('/api/reminders/active', config);
      setActiveReminders(activeRes.data.reminders);
      
      // Pasif hatırlatmaları getir
      const inactiveRes = await axios.get('/api/reminders/inactive', config);
      setInactiveReminders(inactiveRes.data.reminders);
      
      // Kullanılan e-mail adreslerini getir
      const emailsRes = await axios.get('/api/reminders/emails', config);
      setUsedEmails(emailsRes.data.emails);
    } catch (error) {
      toast.error('Hatırlatmalar yüklenirken bir hata oluştu');
      console.error('Hatırlatma yükleme hatası:', error);
    } finally {
      setLoading(false);
    }
  };
  
  // Sayfa yüklendiğinde hatırlatmaları getir
  useEffect(() => {
    fetchReminders();
  }, []);
  
  // Modalı aç
  const handleShowModal = () => {
    resetForm();
    setIsEditing(false);
    setCurrentReminder(null);
    setShowModal(true);
  };
  
  // Modalı kapat
  const handleCloseModal = () => {
    setShowModal(false);
  };
  
  // Formu sıfırla
  const resetForm = () => {
    setTitle('');
    setDescription('');
    setDateTime('');
    setAdditionalEmails([]);
    setIsRecurring(false);
    setRecurringCount(1);
    setRecurringType('day');
    setEmailInput('');
    setIsPublic(false);
  };
  
  // Düzenleme modalını aç
  const handleEdit = (reminder) => {
    setCurrentReminder(reminder);
    setIsEditing(true);
    
    // Form alanlarını doldur
    setTitle(reminder.title);
    setDescription(reminder.description || '');
    
    // Tarihi yerel formata dönüştür
    const localDateTime = new Date(reminder.dateTime);
    console.log('Orijinal Tarih:', localDateTime);
    
    // Tarih formatını YYYY-MM-DDTHH:mm olarak ayarla (HTML datetime-local input için)
    const formattedDate = moment(localDateTime).format('YYYY-MM-DDTHH:mm');
    
    console.log('Formatlanmış Tarih:', formattedDate);
    setDateTime(formattedDate);
    
    setAdditionalEmails(reminder.additionalEmails || []);
    setIsRecurring(reminder.isRecurring || false);
    setRecurringCount(reminder.recurringCount || 1);
    setRecurringType(reminder.recurringType || 'day');
    setIsPublic(reminder.isPublic || false);
    
    setShowModal(true);
  };
  
  // Silme modalı için state
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [reminderToDelete, setReminderToDelete] = useState(null);
  
  // Silme modalını aç
  const handleShowDeleteModal = (reminder) => {
    setReminderToDelete(reminder);
    setShowDeleteModal(true);
  };
  
  // Silme modalını kapat
  const handleCloseDeleteModal = () => {
    setReminderToDelete(null);
    setShowDeleteModal(false);
  };
  
  // Hatırlatma sil
  const handleDelete = async () => {
    if (!reminderToDelete) return;
    
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      
      await axios.delete(`/api/reminders/${reminderToDelete._id}`, config);
      
      toast.success('Hatırlatma başarıyla silindi');
      
      // Modalı kapat ve hatırlatmaları yeniden yükle
      handleCloseDeleteModal();
      fetchReminders();
    } catch (error) {
      toast.error('Hatırlatma silinirken bir hata oluştu');
      console.error('Hatırlatma silme hatası:', error);
    }
  };
  
  // E-mail ekle
  const handleAddEmail = (e) => {
    e.preventDefault();
    
    if (!emailInput) return;
    
    // E-mail formatını kontrol et
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailInput)) {
      toast.error('Geçerli bir e-mail adresi girin');
      return;
    }
    
    // Zaten eklenmiş mi kontrol et
    if (additionalEmails.includes(emailInput)) {
      toast.error('Bu e-mail adresi zaten eklenmiş');
      return;
    }
    
    setAdditionalEmails([...additionalEmails, emailInput]);
    setEmailInput('');
    
    // E-mail input'una focus ol
    document.getElementById('emailInput').focus();
  };
  
  // E-mail kaldır
  const handleRemoveEmail = (email) => {
    setAdditionalEmails(additionalEmails.filter(e => e !== email));
  };
  
  // E-mail input'unda tuşa basıldığında
  const handleEmailKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      handleAddEmail(e);
    }
  };
  
  // Hatırlatma oluştur veya güncelle
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      
      const utcDateTime = new Date(dateTime).toISOString();
      
      const reminderData = {
        title,
        description,
        dateTime: utcDateTime,
        additionalEmails,
        isRecurring,
        recurringCount: isRecurring ? recurringCount : 0,
        recurringType: isRecurring ? recurringType : 'day',
        isPublic,
        user: {
          firstName: user.firstName,
          lastName: user.lastName,
          _id: user._id
        }
      };
      
      if (isEditing && currentReminder) {
        await axios.put(`/api/reminders/${currentReminder._id}`, reminderData, config);
        toast.success('Hatırlatma başarıyla güncellendi');
      } else {
        await axios.post('/api/reminders', reminderData, config);
        toast.success('Hatırlatma başarıyla oluşturuldu');
      }
      
      handleCloseModal();
      fetchReminders();
    } catch (error) {
      const message = error.response?.data?.message || 'Bir hata oluştu';
      toast.error(message);
      console.error('Hatırlatma kaydetme hatası:', error);
    }
  };
  
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Hoş Geldiniz, {user.firstName}!</h2>
        <Button variant="primary" onClick={handleShowModal}>
          Yeni Hatırlatma
        </Button>
      </div>
      
      <Tabs defaultActiveKey="active" className="mb-3">
        <Tab eventKey="active" title="Aktif Hatırlatmalar">
          {loading ? (
            <div className="text-center my-3">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </Spinner>
            </div>
          ) : activeReminders.length === 0 ? (
            <p className="text-muted text-center">Aktif hatırlatma bulunmuyor.</p>
          ) : (
            <ReminderList 
              reminders={activeReminders}
                onEdit={handleEdit}
                onDelete={handleShowDeleteModal}
              />
          )}
        </Tab>
        
        <Tab eventKey="inactive" title="Pasif Hatırlatmalar">
          {loading ? (
            <div className="text-center my-3">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </Spinner>
            </div>
          ) : inactiveReminders.length === 0 ? (
            <p className="text-muted text-center">Pasif hatırlatma bulunmuyor.</p>
          ) : (
            <ReminderList 
              reminders={inactiveReminders}
                onEdit={handleEdit}
                onDelete={handleShowDeleteModal}
              />
          )}
        </Tab>
      </Tabs>
      
      {/* Silme Onay Modalı */}
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Hatırlatma Sil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>{reminderToDelete?.title}</strong> başlıklı hatırlatmayı silmek istediğinize emin misiniz?
          </p>
          <p className="text-danger">Bu işlem geri alınamaz!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            İptal
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Sil
          </Button>
        </Modal.Footer>
      </Modal>
      
      {/* Hatırlatma Ekleme/Düzenleme Modalı */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? 'Hatırlatma Düzenle' : 'Yeni Hatırlatma'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Başlık</Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
                autoComplete="off"
                autoFocus
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Açıklama</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                autoComplete="off"
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Tarih ve Saat</Form.Label>
              <Form.Control
                type="datetime-local"
                value={dateTime}
                onChange={(e) => setDateTime(e.target.value)}
                required
                autoComplete="off"
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Diğer Hatırlatma E-mail Adresleri</Form.Label>
              <div className="d-flex">
                <Form.Control
                  id="emailInput"
                  type="email"
                  value={emailInput}
                  onChange={(e) => setEmailInput(e.target.value)}
                  onKeyDown={handleEmailKeyDown}
                  placeholder="E-mail adresini yazıp Enter'a basın"
                  autoComplete="off"
                />
                <Button 
                  variant="outline-primary" 
                  onClick={handleAddEmail}
                  className="ms-2"
                >
                  Ekle
                </Button>
              </div>
              
              {/* Önceden kullanılan e-mail adresleri */}
              {emailInput && (
                <div className="mt-2 mb-2">
                  <small className="text-muted">Önceden kullanılan e-mailler:</small>
                  <div className="mt-1">
                    {usedEmails
                      .filter(email => email.toLowerCase().includes(emailInput.toLowerCase()))
                      .map((email, index) => (
                        <Badge 
                          key={index} 
                          bg="light" 
                          text="dark" 
                          className="me-1 mb-1 p-2"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setEmailInput(email);
                            document.getElementById('emailInput').focus();
                          }}
                        >
                          {email}
                        </Badge>
                      ))
                    }
                  </div>
                </div>
              )}
              
              <div className="mt-2">
                {additionalEmails.map((email, index) => (
                  <EmailTag
                    key={index}
                    email={email}
                    onRemove={handleRemoveEmail}
                  />
                ))}
              </div>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Check
                type="switch"
                id="isPublicSwitch"
                label="Genel Paylaşım"
                checked={isPublic}
                onChange={(e) => setIsPublic(e.target.checked)}
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Tekrarlı Hatırlatma"
                checked={isRecurring}
                onChange={(e) => setIsRecurring(e.target.checked)}
              />
            </Form.Group>
            
            {isRecurring && (
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tekrar Sayısı</Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      value={recurringCount}
                      onChange={(e) => setRecurringCount(parseInt(e.target.value))}
                      required={isRecurring}
                      autoComplete="off"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tekrar Türü</Form.Label>
                    <Form.Select
                      value={recurringType}
                      onChange={(e) => setRecurringType(e.target.value)}
                      required={isRecurring}
                    >
                      <option value="minute">Dakika</option>
                      <option value="hour">Saat</option>
                      <option value="day">Gün</option>
                      <option value="month">Ay</option>
                      <option value="year">Yıl</option>
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>
            )}
            
            <div className="d-flex justify-content-end">
              <Button variant="secondary" onClick={handleCloseModal} className="me-2">
                İptal
              </Button>
              <Button variant="primary" type="submit">
                {isEditing ? 'Güncelle' : 'Oluştur'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Home;
